'use es6';

import { List } from 'immutable';
import { FieldTypes } from '../../schema/column-records';
import { Reference, ReferenceSources } from './references-records';
export const CHECKBOX_DELIMITER = ';';
export const isCheckboxProperty = snowflakeProperty => {
  const {
    type,
    metaDefinition = {}
  } = snowflakeProperty;
  return type === FieldTypes.ENUMERATION && metaDefinition.fieldType === 'checkbox';
};
const identity = i => i;
export const createCheckboxResolver = resolver => (ids, getFallbackReference) => {
  // Map<ID, List<ID>>
  const explodedIds = ids.toMap().mapKeys((_, delimitedId) => delimitedId).map(delimitedId => List(delimitedId.split(CHECKBOX_DELIMITER)));

  // Set<ID>
  const idSet = explodedIds.toSet().flatten(1);

  /**
   * @param {ID} original
   * @param {List<ID>} split
   * @param {Map<ID, Reference>} lookup
   * @returns {Reference}
   */
  const createCheckboxReference = (original, split, lookup) => {
    const references = split.map(id => lookup.get(id));
    return Reference({
      id: original,
      label: references.map(reference => reference.label).join(', '),
      source: ReferenceSources.CHECKBOX_OPTIONS
    });
  };
  return resolver(idSet, getFallbackReference).then(lookup => explodedIds.map((split, original) => createCheckboxReference(original, split, lookup)));
};
export const withCheckbox = snowflakeProperty => isCheckboxProperty(snowflakeProperty) ? createCheckboxResolver : identity;